import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyOtaHotelSearch = loadable(() => import(/* webpackChunkName: "content/hotel/search/ota", webpackPrefetch: true */ './OtaHotelSearch'), 'OtaHotelSearch');
